import {
  STRIPE_PAYMENT_FETCHING,
  STRIPE_PAYMENT_SUCCESS,
  STRIPE_PAYMENT_ADD_SUCCESS,
  STRIPE_PAYMENT_ADD_FAILED,
  STRIPE_PAYMENT_EDIT_SUCCESS,
  STRIPE_PAYMENT_EDIT_FAILED,
  STRIPE_PAYMENT_DELETE_SUCCESS,
  STRIPE_PAYMENT_DELETE_FAILED,
  STRIPE_PAYMENT_FAILED,
  STRIPE_PAYMENT_CLEAR,
  } from "../services/Constants";
    
    export interface StripePaymentState {
        result: any[];
        isFetching: boolean;
        isError: boolean;
        isAdddata: boolean,
        isEditdata: boolean,
        isAddError: boolean;
        isEditError: boolean;
        isDeletedata: boolean;
        isDeleteError: boolean;
    }
    
    const initialState: StripePaymentState = {
        result: [],
        isFetching: false,
        isError: false,
        isAdddata: false,
        isEditdata: false,
        isAddError: false,
        isEditError: false,
        isDeletedata: false,
        isDeleteError: false,
    };
    
    export default (state = initialState, { type, payload}: any) => {
      switch (type) {
        case STRIPE_PAYMENT_FETCHING:
          return { ...state, result: [], isFetching: true,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: false,isDeletedata: false,isDeleteError: false};
        case STRIPE_PAYMENT_SUCCESS:
          return { 
            ...state, 
            result: payload,
            isFetching: false,
            isAdddata: false,
            isEditdata: false,
            isError: false,
            isAddError: false,
            isEditError: false,
            isDeletedata: false,
            isDeleteError: false
          };
          case STRIPE_PAYMENT_ADD_SUCCESS:
          return { 
            ...state, 
            isFetching: false,
            isAdddata: true,
            isEditdata: false, 
            isError: false,
            isAddError: false,
            isEditError: false,
            isDeletedata: false,
            isDeleteError: false
          };
          case STRIPE_PAYMENT_EDIT_SUCCESS:
          return { 
            ...state, 
            isFetching: false, 
            isAdddata: false,
            isEditdata: true, 
            isError: false,
            isAddError: false,
            isEditError: false,
            isDeletedata: false,
            isDeleteError: false
          };
        case STRIPE_PAYMENT_FAILED:
          return { ...state, result: [], isFetching: false,isAdddata: false,isEditdata: false,
             isError: true,isAddError: false,isEditError: false,isDeletedata: false,isDeleteError: false};
        case STRIPE_PAYMENT_ADD_FAILED:
          return { ...state, result: [], isFetching: false,isAdddata: false,isEditdata: false,
             isError: false,isAddError: true,isEditError: false,isDeletedata: false,isDeleteError: false};
          case STRIPE_PAYMENT_EDIT_FAILED:
          return { ...state, result: [], isFetching: false,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: true,isDeletedata: false,isDeleteError: false};
            case STRIPE_PAYMENT_DELETE_SUCCESS:
          return { ...state, result: [], isFetching: false,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: false,isDeletedata: true,isDeleteError: false};
            case STRIPE_PAYMENT_DELETE_FAILED:
          return { ...state, result: [], isFetching: false,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: false,isDeletedata: false,isDeleteError: true};
        default:
          return state;
      }
      
    };
    